import { Component, namespace, Vue } from 'nuxt-property-decorator';
import { namespace as cartStore, actionType, IUpdateCartItemParams } from '../store/modules/cart-store';
import { ICartItem } from '../entities/cart-entity';

const CartStore = namespace(cartStore);

@Component({
	async fetch(this: CartMixin): Promise<void> {
		// await this.getCart(); // Вызввается в лаяйтуе
	},
})
export default class CartMixin extends Vue {
	@CartStore.Action(actionType.GET_CART) getCart!: () => Promise<void>;
	@CartStore.Action(actionType.UPDATE_CART_ITEM) updateCartItem!: (params: IUpdateCartItemParams) => Promise<boolean>;
	@CartStore.Action(actionType.REMOVE_CART_ITEM) removeCartItem!: (id: string) => Promise<void>;
	@CartStore.Getter items!: ICartItem[];
	@CartStore.Getter totalSum!: number;
	@CartStore.Getter itemsCount!: number;
	@CartStore.Getter discount!: number;

	formatPrice(price: number): string {
		const value = new Intl.NumberFormat('ru-RU').format(price);
		return `${value} ₽`;
	}

	async changeQuantity(quantity: number, item: ICartItem): Promise<boolean> {
		const success = await this.updateCartItem({ cartItemId: item.id, quantity });
		return success;
	}

	remoteItem(id: string): void {
		this.removeCartItem(id);
	}
}
